const OCORRENCIAS_QUERY_KEY = 'occurrences'
export const getOcorrenciasQueryKey = (siteId: number) => [OCORRENCIAS_QUERY_KEY, siteId]
